import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { defineComponent, onMounted, reactive } from "vue";
  import { useRoute } from 'vue-router';

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/planosService";

  //componentes
  import ReportView from "@/components/ReportView/Index.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Ler',
  setup(__props) {

  var controle = reactive({
    filtros: {
      paginaAtual: 1,
      tamanhoPagina: 1
    } as unknown as service.Filtros,
    model: {} as service.Plano,


    status: "",
    erro: "",
  })

  onMounted(async ()=>{
    pesquisar();
  })

  async function pesquisar() {

    service.obter(controle.filtros)
    .then(r=> {
      controle.model = r[0];
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Planos" }),
    _createVNode(ReportView, { titulo: 'Plano' }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          innerHTML: _unref(controle).model.texto
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    })
  ], 64))
}
}

})